import axios from "axios";
import { buildProductIdentityQueryString } from "../../utils/productIdentityQueryUtils";

const API_URL = process.env.REACT_APP_API_URL;

export const getProductosYMuestras = async () => {
  const token = localStorage.getItem("token");
  const response = await axios.get(`${API_URL}/api/productos-muestras`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
};

export const fetchProductIdentity = async ({
  nombre,
  idProducto,
  idMuestra,
} = {}) => {
  const token = localStorage.getItem("token");
  const query = buildProductIdentityQueryString({ nombre, idProducto, idMuestra });

  const response = await axios.get(
    `${API_URL}/api/productos-muestras/identity?${query}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  );
  return response.data;
};
